<template>
  <div class="container report">
    <div class="searchCondition">
		<el-select v-model="searchKey" style="width: 120px" size="mini">
				<el-option key="offer_id" label="offer id" value="offer_id" />
				<el-option key="package_id" label="package id" value="package_id" />
		</el-select>
      <el-input
        v-model="searchValue"
        style="width: 300px"
        placeholder="Separated by ','"
        clearable
		size="mini"
      ></el-input>
      <el-button size="mini" @click="search">Search</el-button>
      <exportcsv :rows="rows" filename="Offer" :tableObj="$refs.table"></exportcsv>
			<!-- <el-switch v-model="showKpi" active-text="Show KPI"></el-switch> -->
			<el-checkbox-group class="props"
				v-model="checkedProps">
      <el-checkbox v-for="p in allProps" :label="p" :key="p">{{p}}</el-checkbox>
  </el-checkbox-group>
    </div>
    <el-table
      :data="rows"
      border
      stripe
      class="channel-table"
      v-loading="loading"
      header-row-class-name="table-header"
      row-class-name="channel-table-row"
      element-loading-background="rgba(0, 0, 0, 0.2)"
			ref="table"
    >
      <el-table-column prop="offer_id" label="Offer Id" width="140">
      </el-table-column>
      <el-table-column prop="offer_name" label="Offer Name" >
      </el-table-column>
      <el-table-column prop="package_id" label="Package Id" width="140">
      </el-table-column>
      <el-table-column prop="country" label="Country" width="110">
      </el-table-column>
      <el-table-column prop="os" label="OS" width="110"></el-table-column>

      <el-table-column prop="payout" label="Payout($)" width="110">
        <span slot-scope="sp">{{
          `\$${sp.row.payout} ${sp.row.payout_type}`
        }}</span>
      </el-table-column>
      <el-table-column label="KPI" prop="kpi" v-if="checkedProps.indexOf('kpi')>-1"/>

      <el-table-column label="Tracking Link" prop="tracking_link">
      </el-table-column>
      <el-table-column label="Impression Link" prop="impression_link" v-if="checkedProps.indexOf('imp_link')>-1">
      </el-table-column>
      <el-table-column label="Preview" prop="preview">
        <a slot-scope="sp" :href="sp.row.preview_url" target="_blank">{{
          sp.row.preview_url
        }}</a>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[20,50,100]"

    >
    </el-pagination>
  </div>
</template>
<script>
import { post } from "@/lib/channelClient";
import exportcsv from '@/components/channelClient/exportcsv.vue';

const allProps=['kpi', 'imp_link']
export default {
	components:{
		exportcsv,
	},
	data() {
		return {
			searchKey: 'offer_id',
			searchValue: '',
			rows: [],
			total: 0,
			limit: 100,
			page: 1,
			loading: false,
			showKpi: false,
			checkedProps:[],
			allProps,
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async logout() {
			await post("/channelClient/logout", {});
			window.location.href = "/login";
		},
		async search() {
			this.loading = true;
			const res = await post("/channelClient/offers", { page: this.page, size: this.limit, keyword: this.searchValue, searchKey: this.searchKey });
			const body = await res.json();
			this.loading = false;
			this.rows = body.offers;
			this.total = body.counts;
		},
	},
};
</script>
<style scoped>
.props{
	margin-left: 20px;
}
.channel-table-row {
	padding: 10px 0;
}
.channel-table > :nth-child(3) {
	height: calc(100% - 30px);
	overflow-y: scroll;
}

</style>